import { PROGRESS_FORM_DOCUMENT_ANON, PROGRESS_FORM_DOCUMENT_AUTH } from 'app-constants';
import { apiServer } from 'settings/web-services/api';

export const progressSmartFormValuesAuth = ({ formProcessPublicId, formDocumentPublicId }) =>
  apiServer.post(PROGRESS_FORM_DOCUMENT_AUTH({ formProcessPublicId, formDocumentPublicId }), {});

export const progressSmartFormValuesAnon = ({ type, ...cfg }) =>
  apiServer.post(PROGRESS_FORM_DOCUMENT_ANON({ type }), cfg);
